@if (conversations && conversations.length && userAccount) {
  <div
    class="appear_1"
    (click)="isOnline() ? '' : sharedService.noInternetSnackbar()"
  >
    @for (convo of conversations; track convo.id) {
      <div [ngClass]="{ 'no-pointer-events': !isOnline() }">
        <a
          [routerLink]="getRouterLink(convo)"
          [queryParams]="getQueryParams(convo)"
          #rla="routerLinkActive"
          routerLinkActive="active"
          (click)="handleConversationClick(convo)"
        >
          <app-conversation-card
            [userAccount]="userAccount"
            [selected]="rla.isActive"
            [inConversationList]="true"
            [refreshCount]="convo.refreshCount"
            (muteStatus)="muteStatusChange($event, convo)"
            [convo]="convo"
            [isRolesSidenav]="isRolesSidenav"
            [isScribeSidenav]="isScribeSidenav"
            [disableConversationActions]="disableConversationActions"
          ></app-conversation-card>
        </a>
      </div>
    }
    <div style="padding-left: 1em; margin-bottom: 1em; padding-right: 1em">
      @if (conversations.length > 0 && canLoadMore && !loading) {
        <div style="padding-top: 1em">
          <div style="padding-top: 1em">
            <button
              class="fw button-hover"
              mat-button
              (click)="loadMore.emit($event)"
            >
              Load More
            </button>
          </div>
        </div>
      }
      @if (loading) {
        <div class="spinner-box">
          <div class="spinner">
            <mat-spinner diameter="20" strokeWidth="2"></mat-spinner>
          </div>
        </div>
      }
    </div>
  </div>
}
